module.exports = __webpack_public_path__ + "img/card-media-slider-03.103b17b4.png";